import * as types from '../types';

  const initialState = {
    loanResponse: null,
    error: false,
    loading: false,
    userToken: JSON.parse(localStorage.getItem('decoded') || '{}'),
  };
  
  const loanApplicationReducer = (state = initialState, action:any) => {
    const { type, payload } = action;
    
    switch (type) {
      case types.LOAN_APPLY_BEGIN:
        return {
          ...state,
          loading: true,
          loanResponse: null,
          error: null,
        };

      case types.LOAN_APPLY_SUCCESS:
        return {
          ...state,
            loanResponse: payload,
            error: false,
            loading: false,
        };

      case types.LOAN_APPLY_FAILURE:
        return {
          ...state,
          loanResponse: '{}',
          loading: false,
          error: true,
        };
        case types.LOAN_APPLY_RESET:
        return {
          ...state,
          loanResponse: null,
          loading: false,
          error: false,
        };
      default:
        return state;
    }
  }

  export default loanApplicationReducer;